import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const TextInput = props => {
  const {
    field: { touched, error, ...field },
    placeholder,
    type,
  } = props;

  delete field.initialValue;
  delete field.autofill;
  delete field.onUpdate;
  delete field.valid;
  delete field.invalid;
  delete field.dirty;
  delete field.pristine;
  delete field.active;
  delete field.visited;
  delete field.autofilled;

  const formGroupClass = classnames("form-group", {
    "has-error": touched && error,
  });
  return (
    <div className={formGroupClass}>
      <input
        type={type || "text"}
        placeholder={placeholder}
        {...field}
        value={field.value !== undefined ? field.value : undefined}
        defaultValue={
          field.value !== undefined ? undefined : field.initialValue
        }
        className="form-control"
      />
      {touched && error && <div className="help-block">{error}</div>}
    </div>
  );
};

TextInput.propTypes = {
  field: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.object,
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.js